export default __webpack_public_path__ + "static/media/search.311400ee.svg";